/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const { setDevFeaturesEnabled, setShowDisabledUsers } = createActions(
	{
		SET_DEV_FEATURES_ENABLED: enable => ({ enable }),
		SET_SHOW_DISABLED_USERS: show => ({ show })
	},
	{ prefix: ROOT_SLICE }
);

export { setDevFeaturesEnabled, setShowDisabledUsers };
